import { useState } from 'react';
import { SharingStatsCards } from '@/components/sharing/SharingStats';
import { ActivityTimeline } from '@/components/sharing/ActivityTimeline';
import { SharedResourcesList } from '@/components/sharing/SharedResourcesList';
import { SharedWithMeList } from '@/components/sharing/SharedWithMeList';
import { GroupsManagementCard } from '@/components/sharing/GroupsManagementCard';
import { TabCards } from '@/components/sharing/TabCards';
import { useSharing } from '@/hooks/useSharing';
import { useSharedWithMe } from '@/hooks/useSharedWithMe';
import { useGroupsManagement } from '@/hooks/useGroupsManagement';
import { ShareFilterType } from '@/types/sharing';
import { Share2 } from 'lucide-react';
import { Tabs, TabsContent } from '@/components/ui/tabs';

export default function Sharing() {
  const [filter, setFilter] = useState<ShareFilterType>('all');
  const [activeTab, setActiveTab] = useState('shares');
  const { stats, resources, isLoading } = useSharing(filter);
  const { data: sharedWithMe, isLoading: isLoadingSharedWithMe } = useSharedWithMe();
  const { groups, isLoading: isLoadingGroups } = useGroupsManagement();

  return (
    <div className="container mx-auto p-6 space-y-6">
      {/* Header */}
      <div>
        <div className="flex items-center gap-2 mb-2">
          <Share2 className="h-8 w-8 text-primary" />
          <h1 className="text-3xl font-bold">Compartilhamento</h1>
        </div>
        <p className="text-muted-foreground">
          Gerencie recursos compartilhados e grupos
        </p>
      </div>

      {/* Estatísticas */}
      <SharingStatsCards 
        stats={stats} 
        isLoading={isLoading}
        sharedWithMeCount={sharedWithMe?.length || 0}
      />

      {/* Tab Cards */}
      <TabCards
        activeTab={activeTab}
        onTabChange={setActiveTab}
        mySharesCount={resources?.length || 0}
        sharedWithMeCount={sharedWithMe?.length || 0}
        groupsCount={groups?.length || 0}
      />

      {/* Tabs Content */}
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        {/* Tab: Meus Compartilhamentos */}
        <TabsContent value="shares" className="space-y-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="lg:col-span-1">
              <ActivityTimeline />
            </div>
            <div className="lg:col-span-2">
              <SharedResourcesList
                resources={resources}
                isLoading={isLoading}
                filter={filter}
                onFilterChange={setFilter}
              />
            </div>
          </div>
        </TabsContent>

        {/* Tab: Compartilhados Comigo */}
        <TabsContent value="shared-with-me" className="space-y-6">
          <SharedWithMeList
            resources={sharedWithMe}
            isLoading={isLoadingSharedWithMe}
          />
        </TabsContent>

        {/* Tab: Grupos */}
        <TabsContent value="groups">
          <GroupsManagementCard />
        </TabsContent>
      </Tabs>
    </div>
  );
}
